<div #canvasCSS3d id="canvasCSS3d"></div>
<canvas #canvas3d id="canvas3d" style="width: 100%;height:100%;" tabindex="0"  uzunBas [uzunBasSure]="250" (uzunBasildi)="gomulu ? null : secililer?.uzunBasildi($event)"></canvas>

<!-- Sürükle-Bırak Drop Zone Overlay -->
@if (dropZoneAktif) {
<div class="fiko-drop-zone-overlay" (drop)="onDrop($event)" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)">
    <div class="fiko-drop-zone-icerik">
        <div class="fiko-drop-zone-simge">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                <polyline points="17 8 12 3 7 8"/>
                <line x1="12" y1="3" x2="12" y2="15"/>
            </svg>
        </div>
        <div class="fiko-drop-zone-baslik">Dosyaları buraya bırakın</div>
        <div class="fiko-drop-zone-aciklama">STP, STEP, WRL, PLY, OBJ, STL ve daha fazlası</div>
    </div>
</div>
}

<!-- Progress ve Mesaj UI - Minimal Floating -->
@if (yuklemeDurumu.aktif) {
<div class="progress-floating">
    <!-- Progress Bar -->
    <div class="progress-bar-bg-float">
        <div class="progress-bar-fill-float" [style.width.%]="yuklemeDurumu.progress"></div>
    </div>

    <!-- Mesaj ve Yüzde -->
    <div class="progress-info-float">
        <span class="progress-message-float">{{yuklemeDurumu.mesaj}}</span>
        <span class="progress-percent-float">%{{yuklemeDurumu.progress.toFixed(0)}}</span>
    </div>
</div>
}

<!-- Render Mode Göstergesi -->
<!-- <div style="position: fixed; top: 10px; right: 10px; padding: 8px 16px; background-color: #f5f5f5; border-radius: 4px; font-size: 12px; box-shadow: 0 2px 4px rgba(0,0,0,0.1); z-index: 1000;">
    <span style="color: #666;">Render: <strong>{{ renderModeDurumu }}</strong></span>
</div> -->

<!-- <div class="ui active dimmer" *ngIf="FikoYT?.mesgul1?.aktif">
    <img src="/resimler/logo.webp" style="height: 64px;margin-top:14px;">
    <div class="ui text massive loader" style="margin-top: 2em;width: 100%;">
        {{ FikoYT?.mesgul1?.baslik }}<br>
        {{ FikoYT?.mesgul1?.aciklama }}<br>
        <meter *ngIf="FikoYT?.mesgul1?.gosterCubuk" [min]="FikoYT?.mesgul1?.min" [max]="FikoYT?.mesgul1?.maks" low="20"
            high="100" optimum="50" [value]="FikoYT?.mesgul1?.durum">
        </meter>
    </div>
</div> -->





<!-- <fikoyt-fiko-eksen #DialogFikoEksen></fikoyt-fiko-eksen> -->
<!-- <fikoyt-fikogram #DialogFikogram></fikoyt-fikogram>
<fikoyt-fiko-similasyon #DialogFikoSimilasyon></fikoyt-fiko-similasyon>
<fikoyt-fiko-similasyon-v1 #DialogFikoSimilasyonv1></fikoyt-fiko-similasyon-v1>
<fikoyt-fikoperasyon #DialogFikoperasyon></fikoyt-fikoperasyon>
<fikoyt-fikoapt #DialogFikoApt></fikoyt-fikoapt>
<fikoyt-fiko-takim-yolu-duzenleyici #DialogFikoTakimYoluDuzenleyici></fikoyt-fiko-takim-yolu-duzenleyici>


<fikoyt-fiko-isik-ortam #DialogFikoIsikOrtam></fikoyt-fiko-isik-ortam>
<fikoyt-fiko-isik-yonsel #DialogFikoIsikYonsel></fikoyt-fiko-isik-yonsel>

<fikoyt-3dyazi-isaretleyici #DialogFiko3dYaziIsaretleyici></fikoyt-3dyazi-isaretleyici>

<fikoyt-dialog-fiko-puntalama #DialogFikoPuntalama></fikoyt-dialog-fiko-puntalama>

<fikoyt-konumlar #DialogKonumlar></fikoyt-konumlar> -->

<fikoyt-3d-hizli-menu #Dialog3DHizliMenu></fikoyt-3d-hizli-menu>

<ng-template #itemMenu let-grup>

    <section class="item-menu">
        <div style="display: flex;align-items: center;justify-content: center;">
            <div
                style="margin-bottom: 0.2rem;padding: 2px 10px;border-radius: 50vh;font-weight: bolder;color: white;text-shadow: 0 0 10px rgb(0 255 255 / 95%);pointer-events: all;font-size: 0.90em;">
                <img [src]="grup?.userData?.FikoArayuz?.simge"
                    style="width: 16px !important;height: 16px;object-fit: contain;">
                {{grup?.name ?? "FikoYT Obje" }}

            </div>
        </div>

        <ng-container *ngFor="let itm of grup?.sagMenu; trackBy: trackByMenuBaslik">

            <ng-container [ngSwitch]="itm.tipi">
                <ng-container *ngSwitchCase="'Ayraç'">
                    <hr />
                </ng-container>
                <ng-container *ngSwitchDefault>
                    <div class="menuDiv" (click)="itm.tiklandi();kapaSagMenu();">
                        <i class="ui icon {{ itm.simge }}">{{ itm.simgeYazi }}</i>
                        {{itm.baslik}}</div>
                </ng-container>

                <ng-container *ngSwitchCase="'Grup'">
                    <span (click)="itm.tiklandi ? itm.tiklandi():null ;kapaSagMenu();"
                        style="color: white;">
                        <i class="ui icon {{ itm.simge }}">{{ itm.simgeYazi }}</i>
                        {{itm.baslik}}</span>
                    <div style="margin-left: 0.5rem;" *ngFor="let altitm of itm?.alt; trackBy: trackByMenuBaslik">
                        <ng-container *ngTemplateOutlet="menuitem; context:{ $implicit: altitm }"></ng-container>
                    </div>

                </ng-container>

            </ng-container>

        </ng-container>

    </section>
</ng-template>

<ng-template #menuitem let-item>
    <ng-container [ngSwitch]="item.tipi">
        <ng-container *ngSwitchCase="'Ayraç'">
            <hr />
        </ng-container>
        <ng-container *ngSwitchDefault>
            <div class="menuDiv" (click)="item.tiklandi();kapaSagMenu();" *ngIf="item.gorunur ? item.gorunur():true">
                <i class="ui icon {{ item.simge }}">{{ item.simgeYazi }}</i>
                {{item.baslik}}</div>
        </ng-container>
    </ng-container>
</ng-template>